<template>
  <div class="main">
    <div class="list-bg"><img :src="bkimg" alt=""></div>
    <div class="contain">
      <div class="navigate pointer">
        <span :class='{"lastnav":index==navigate.length-1}' v-for='(nav,index) in navigate' :key='index' @click="gotot(index)">{{nav}}<span class='lastnav' v-show='index != navigate.length-1'>></span></span>
      </div>
      <div class="boat">
        <div class="title flex flexs"><span>南极船票</span> <span class='selmore' @click ='goto(sourth)'>查看更多 >></span></div>
        <boat :boatitems ='littlepics'></boat>
        <div class="title flex flexs"><span>北极船票</span> <span class='selmore' @click='goto(north)'>查看更多 >></span></div>
        <boat :boatitems ='northitems'></boat>
        <div class="title flex flexs"><span>自由行攻略</span> <span class='selmore' @click='goto(freestrategy)'>查看更多 >></span></div>
        <free :freeitems='items'></free>
        <div class="title flex flexs"><span>往期回顾</span> <span class='selmore' @click='goto(pastreview)'>查看更多 >></span></div>
        <past :lists='lists'></past>
      </div>
    </div>
  </div>
</template>
<script>
import Calendar from '../components/vue-calendar-component/index'
import { shiplist } from '@/api/ship.js'
import vuePagition from '../components/vue-pagition/vue-pagition'
import { menulist } from '@/api/header.js'
import {strategylist} from '@/api/free.js'
import {formateDateNumber, toChinesNum} from '@/utils/index.js'
import free from '@/components/free/free.vue'
import {reviewlist} from '@/api/past.js'
import past from '@/components/past/past.vue'
import boat from '@/components/boat/boat.vue'
export default {
  components: {
    Calendar, vuePagition, free, past, boat
  },
  data () {
    return {
      navigate: ['首页', '极地自由行'],
      trip: {},
      trips: [{name: '南极半岛', active: false, id: 0}, {name: '南极圈', active: false, id: 1}],
      tripshow: false,
      triptype: {},
      triptypes: [{name: '船去船回', active: false, id: 0}, {name: '空海航运', active: false, id: 1}],
      typeshow: false,
      starttimeshow: false,
      starttime: '',
      endtimeshow: false,
      endtime: '',
      keyword: '',
      luxuryboats: {
      },
      explore: {},
      eitems: [],
      largepics: [],
      littlepics: [],
      querylist: {
        page: 1,
        limit: 4
      },
      bkimg: '',
      lists: [],
      northitems: []
    }
  },
  mounted () {
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    if (this.$route.query.name) {
      this.navigate[1] = this.$route.query.name
    }
    if (this.$route.query.id) {
      this.querylist.menuId = this.$route.query.id
    }
    this.trip = this.trips[0]
    this.triptype = this.triptypes[0]
    this.getmenulist()
    this.getpastlist()
    this.getfreelist()
  },
  methods: {
    gotot (index) {
      if (index === 0) {
        this.$router.push({path: '/index'})
      }
    },
    // 获取菜单
    getmenulist () {
      menulist({limit: 1000, sort: 'orderNo', order: 'asc'}).then(res => {
        console.log(1)
        res.data.data.items.forEach(element => {
          if (element.mname === '北极船票预定') {
            this.north = element
          } else if (element.mname === '南极船票预定') {
            this.sourth = element
          } else if (element.mname === '自由行攻略') {
            this.freestrategy = element
          } else if (element.mname === '往期回顾') {
            this.pastreview = element
          }
        })
        this.getlist(this.sourth.id)
        this.getlistN(this.north.id)
      })
    },
    // 获取往期回顾
    getpastlist () {
      let query = {...this.querylist}
      query.limit = 6
      reviewlist(query).then(res => {
        this.lists = this.lists.concat(res.data.data.items)
      })
    },
    getlist (menuId) {
      let data = {...this.querylist}
      data.menuId = menuId
      shiplist(data).then(res => {
        this.littlepics = res.data.data.items
      })
    },
    getlistN (menuId) {
      let data = {...this.querylist}
      data.menuId = menuId
      shiplist(data).then(res => {
        this.northitems = res.data.data.items
      })
    },
    // 获取自由行
    getfreelist () {
      strategylist(this.querylist).then(res => {
        let date = (res.data.data.travelDateList).sort((a, b) => { return a - b })
        this.timeMenus = []
        this.times = []
        this.timeMenus.push({name: '全部'})
        let obj = {year: (new Date()).getFullYear(), child: []}
        for (let key in date) {
          this.timeMenus.push({name: toChinesNum(date[key])})
          obj.child.push({name: toChinesNum(date[key]), status: 1}) // status:0 时间过期， 1：时间有效
        }
        this.times.push(obj)
        let items = res.data.data.items
        for (let i = 0; i < items.length; i++) {
          items[i].publishedtime = formateDateNumber(items[i].publishedtime)
        }
        this.items = items
      })
    },
    // 跳南/北极船票
    goto (item) {
      this.$router.push({
        path: item.url,
        query: {
          id: item.id,
          name: item.mname,
          img: item.topimg
        }
      })
    }
  },
  created () {
  }
}
</script>
<style lang="scss" scoped>
.main{
      background-color:#f4f4f4;
      padding-bottom:40px;
  }
  .pointer{
    cursor: pointer;
  }
  .ivu-select-dropdown {
      margin: 0 !important;
      border-radius: 0px !important;
  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    margin: -200px auto 0;
        position: relative;
  }
  .list-bg {
        width: 100%;
        height: 672px;
        background: url(../static/images/freedetail.png) no-repeat center;
        background-size: cover;
    }
  .list-bg img{
    width:100%;
  }
  .navigate{
    height:3.75rem;
    text-align:left;
    color:#0080cc;
    font-size:.875rem;
    line-height:3.75rem;
    padding-left:1.5rem;
    border-bottom:1px solid #dae1e6;
  }
  .navigate span{
    margin-left:.3125rem;
  }
  .lastnav{
    color:#60676d;
  }
  .alltrip{
    padding:1.5rem;
    border-bottom:1px solid #dae1e6;
  }
   .flex{
    display:flex;
  }
  .flexs{
    justify-content: space-between;
    align-items: baseline;
  }
  .align-items{
    align-items: center;
  }
  .justify-content{
    justify-content: space-between;
  }
  .flex-wrap{
    flex-wrap:wrap;
  }
  .input{
    width:15.5rem;
    height:1.875rem;
    border:1px solid #c6cbd0;
    margin-left:.625rem;
    color:#c6c8ca;
  }
  .tridown{
    width:2rem;
    height:100%;
    background-color:#f5f8fa;
    border-left:1px solid #c6cbd0;
    display:flex;
    align-items: center;
  }
  .tridown img{
    width:.4375rem;
    height:.375rem;
    margin:auto;
  }
  .tridown .date{
    width:1rem;
    height:.9375rem;
    margin:auto;
  }
  .inputcontent{
    padding:.625rem;
    font-size:.875rem;
    color:#c6c8ca;
  }
   .inputcontent1{
     width:14.875rem;
    padding-left: .625rem;
    font-size:.875rem;
    color:#c6c8ca;
    line-height: 1.875rem;
  }
  .triptxt{
    color:#6a7176;
    font-size:1rem;
    padding-top:4px;
  }
  .triptx1{
    padding-top:0;
  }
  .inputDown{
    position: relative;
    z-index:999
  }
  .down{
    position: absolute;
    left:0.625rem;
    top:1.875rem;
    width:15.5rem;
    z-index:9999;
    background-color: #fff;
  }
  .sel{
    width:100%;
    height:2.9375rem;
    line-height: 2.9375rem;
    text-align:center;
    color:#9aa2aa;
    font-size:14px;
    border:1px solid #c6cbd0;
  }
  .active{
    background-color: #0080cc;
    color:#fff;
  }
  .mg20{
    margin-left:1rem;
  }
  .triptype{
    width:13.4375rem;
    border:1px solid #c6cbd0;
  }
   .sel1{
    width:90%;
    height:2.9375rem;
    line-height: 2.9375rem;
    margin:auto;
    text-align:center;
    color:#9aa2aa;
    font-size:14px;
    border-bottom:1px solid #c6cbd0;
    border-top:0;
  }
    .sel1:nth-last-child(1){
    border-bottom:0px solid #c6cbd0;
  }
  .active1{
    background-color: #0080cc;
    color:#fff;
    width:100%
  }
  .time{
    width:21.25rem;
  }
  .triptime{
    width:13.4375rem;
  }
  .btn{
    width:5.25rem;
    height:2.125rem;
    line-height: 2.125rem;
    text-align: center;
    margin-left:.625rem;
    background-color: #0080cc;
    color:#fff;
    border-radius: .25rem;
    font-size:.875rem;
  }
  .largepic{
    width:38.5rem;
    height:31.375rem;
    position: relative;
  }
  .largepic .large{
    width:100%;
    height:100%;
  }
  .boat{
    padding:0 1.5rem;
  }
  .boat .title{
    font-size:1.5rem;
    color:#3f464c;
    margin:1.875rem 0 1.25rem 0;
  }
  .word{
    color:#fff;
    position: absolute;
    top:1.6875rem;
    left:1.25rem;
  }
  .word-title {
    width: 90%;
    background: rgba(0, 0, 0, 0.3);
    padding: 10px 20px;
  }
  .word p{
    margin:0;
    padding:0;
  }
  .word .name span:nth-of-type(1){
    font-size:1.625rem;
  }
  .word .name span:nth-of-type(2){
    font-size:1.125rem;
  }
  .word .descript{
    font-size:1rem;
    margin-top:.5rem;
  }
  .word .jt{
    margin-top:24rem;
    width:2.125rem;
    height:.875rem;
  }
  .bk{
    position: absolute;
    width:38.5rem;
    height:31.375rem;
    top:0;
    left:0;
    background-color:rgba(0, 0, 0, .5);
  }
  .btompic{
    position: absolute;
    left:0;
    bottom:0;
  }
  .littlepic{
    width:19.25rem;
    height:15.6875rem;
    color:#fff;
    position: relative;
  }
  .littlepic .littleimg{
    width:100%;
    height:100%
  }
  .littlepic p{
    margin:0;
    padding:0;
  }
  .littlepic .name span:nth-of-type(1){
    font-size:1.625rem;
  }
  .littlepic .name span:nth-of-type(2){
    font-size:1.125rem;
  }
  .littlepic .descript{
    font-size:1rem;
    margin-top:.5rem;
  }
  .littlepic .jt{
    margin-top:24rem;
    width:2.125rem;
    height:.875rem;
  }
  .bword{
    position: absolute;
    top:1.25rem;
    left:1.25rem;
  }
  .btomword{
    position: absolute;
    bottom:1.25rem;
    left:1.25rem;
  }
  .mjt{
    width:2.125rem;
    height:.875rem;
    position: absolute;
    right:1.25rem;
    top:-2.125rem;
  }
  .starboat {
    cursor: pointer;
    width:18.125rem;
    border:1px solid #e8e8e8;
    padding-bottom:1.25rem;
    margin-top:24px;
    margin-right:20px;
    &:hover {
        box-shadow: 0px 0px 12px #ccc9c9;
        transition: all 0.2s;
        transform: scale(1.02);
    }
  }
  .starboat:nth-of-type(4n+4){
    margin-right:0;
  }
  .starboat img{
    width:100%;
    height:16.625rem;
  }
  .starboat .name{
    font-size:18px;
    color:#434343;
    margin-top:1.25rem;
    margin-left:1.25rem;
  }
  .starboat .descript{
    font-size: 14px;
    color:#7a7a7a;
    margin-top:.5rem;
    margin-left:1.25rem;
  }
  .more{
    font-size: .875rem;
    color:#6a7176;
    font-style:italic;
    text-align: center;
    margin-top:5.5rem;
  }
  .selmore{
    cursor: pointer;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:200;
    color:rgba(0,128,204,1);
  }
</style>



// WEBPACK FOOTER //
// src/views/freeTravel.vue